import { CaseData } from 'modules/cm/api/cases/types';
import { FIELDS } from 'modules/cm/fields/types';
import { Data } from '../Expenditure.types';

export type LiabilityFormData = Data['applicant'][FIELDS.EXPENDITURES_PREFIX][0];
export type LiabilityInitialData = NonNullable<CaseData['applicant1' | 'applicant2']>['expenditures'][0];
export type LiabilityRequestData = NonNullable<CaseData['applicant1' | 'applicant2']>['expenditures'][0];

export interface LiabilityTypeBuilder {
  formData: LiabilityFormData;
  getData: () => LiabilityRequestData;
  setCreditCardBalance: () => void;
  setIsClearedBeforeLoanCompletes: () => void;
  setAmount: () => void;
  setType: () => void;
  setEndDate: () => void;
  setIsClearedByLoanCompletes: () => void;
  setDescription: () => void;
  setFrequency: () => void;
  setTotalNumberOfProperties: () => void;
  setId: () => void;
  setCreditLimit: () => void;
}

export interface LiabilityTypeLabelBuilder {
  getLabel: (field: keyof LiabilityFormData) => string;
  setCreditCardBalance: (label: string) => void;
  setIsClearedBeforeLoanCompletes: (label: string) => void;
  setAmount: (label: string) => void;
  setType: (label: string) => void;
  setEndDate: (label: string) => void;
  setIsClearedByLoanCompletes: (label: string) => void;
  setDescription: (label: string) => void;
  setFrequency: (label: string) => void;
  setTotalNumberOfProperties: (label: string) => void;
  setId: (label: string) => void;
  setCreditLimit: (label: string) => void;
}

export interface DataDirector {
  getData: () => LiabilityRequestData;
  prepareData: (expenditure: LiabilityFormData) => void;
  getAllowedFields: () => FIELDS[];
  getTitle: (field: keyof LiabilityFormData) => string;
}

export enum COMMITMENT_TYPES {
  CREDIT_CARD = 'CREDIT_CARD',
  UNSECURED_LOAN = 'UNSECURED_LOAN',
  MAINTENANCE_PAYMENTS = 'MAINTENANCE',
  STUDENT_LOAN = 'STUDENT_LOAN',
  BUY_TO_LET_MORTGAGE = 'BUY_TO_LET_MORTGAGE',
  PENSION_CONTRIBUTION = 'PENSION',
  OTHER = 'OTHER',
}
